import React, { useState, useEffect } from 'react';
import { FaCookie } from 'react-icons/fa';
import './style.css';

function CookieConsent() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Afișează banner-ul după 1 secundă
            setTimeout(() => {
                setShowBanner(true);
            }, 1000);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setShowBanner(false);
    };

    const declineCookies = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setShowBanner(false);
    };

    if (!showBanner) {
        return null;
    }

    return (
        <div className="cookie-consent-wrapper">
            <div className="cookie-consent-container">
                <div className="cookie-icon">
                    <FaCookie />
                </div>
                <div className="cookie-content">
                    <h4>Politica de Cookie-uri</h4>
                    <p>
                        Acest website folosește cookie-uri pentru a îmbunătăți experiența utilizatorilor și pentru a analiza traficul.
                        Cookie-urile ne ajută să înțelegem cum folosiți site-ul nostru și să vă oferim conținut personalizat.
                        Prin acceptarea cookie-urilor, sunteți de acord cu{' '}
                        <a href="/politica-confidentialitate" target="_blank" rel="noopener noreferrer">
                            Politica de Confidențialitate
                        </a>{' '}
                        și{' '}
                        <a href="/termeni-conditii" target="_blank" rel="noopener noreferrer">
                            Termenii și Condițiile
                        </a>{' '}
                        noastre.
                    </p>
                </div>
                <div className="cookie-buttons">
                    <button onClick={acceptCookies} className="btn-accept">
                        Accept
                    </button>
                    <button onClick={declineCookies} className="btn-decline">
                        Refuz
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;
